export const APP_UI_WORKSPACE_REMOVE_BG_RESET_MODAL =
  "APP/UI/WORKSPACE/REMOVE_BG/RESET/MODAL";
